import React from 'react'
import Head from 'next/head'
import { FaLinkedinIn, FaInstagram } from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <>
<footer className="bg-gray-900 text-white py-10 mt-16 border-t border-gray-800">
  <div className="px-[12%] flex flex-col md:flex-row md:justify-between md:items-start gap-8">

    {/* 左侧：公司信息 */}
    <div className="space-y-3 text-sm md:text-base font-Ovo">
      <small className="block text-gray-400">
        &copy; {currentYear} Simoom Construction Pty Ltd. All rights reserved.
      </small>

      <address className="not-italic space-y-2 text-gray-300">
        <p>
          <span className="font-semibold text-white">Phone:</span>{' '}
          <a href="tel:0450226877" className="hover:underline">
            0450 226 877
          </a>
        </p>

        <p>
          <span className="font-semibold text-white">Address:</span>{' '}
          <a
            href="https://maps.google.com/?q=29+Brandl+Street,+Eight+Mile+Plains+QLD+4113"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            29 Brandl Street, Eight Mile Plains QLD 4113
          </a>
        </p>
      </address>

      <p className="text-gray-300">
        <span className="font-semibold text-white">QBCC:</span> 15234304
        &nbsp; | &nbsp;
        <span className="font-semibold text-white">ABN:</span> 91 644 460 917
      </p>
    </div>

    {/* 右侧：Follow Us */}
    <div className="flex flex-col md:items-end gap-3">
      <span className="text-md uppercase tracking-wider text-amber-400">
        Follow Us
      </span>

      <div className="flex gap-5 text-3xl">
        <a
          href="https://www.linkedin.com/company/simoom-construction"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
          className="text-white hover:text-[#0A66C2] transition hover:-translate-y-0.5"
        >
          <FaLinkedinIn />
        </a>

        <a
          href="https://www.instagram.com/simoomconstruction/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          className="text-white hover:text-pink-500 transition hover:-translate-y-0.5"
        >
          <FaInstagram />
        </a>
      </div>
    </div>

  </div>
</footer>

    </>
  )
}

export default Footer


